module.exports = __webpack_public_path__ + "img/home.652666a0.jpg";